export default __webpack_public_path__ + "react-assets/avatar-read-only-status.svg";